module.exports = __webpack_public_path__ + "img/fileIconGreen.3dac283e.png";